export const AVATAR_COLORS = [
  "bg-pink-500 text-white",
  "bg-orange-500 text-white",
  "bg-green-600 text-white",
  "bg-blue-500 text-white",
  "bg-purple-700 text-white",
  "bg-amber-500 text-white",
  "bg-rose-500 text-white",
  "bg-teal-600 text-white",
];

/**
 * Picks a stable color class from {@link AVATAR_COLORS} based on a hash of `id`.
 * Same `id` always maps to the same color across renders and sessions.
 */
export function getAvatarColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash << 5) - hash + id.charCodeAt(i);
    hash |= 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
